import {CellCoordinates} from '@/types/types';

export default class CellActivator {
    public static activateCell(cell: CellCoordinates): void {
        CellActivator.deactivateCell();
        CellActivator.applyClass('active', cell.x, cell.y, cell.index);
        const row: HTMLElement | null = document.querySelector(`#planbord-holder .planbord-grid-row[data-y="${cell.y}"] .nameMarker`);
        if (row) {
            row.classList.add('active');
        }
        const column: HTMLElement | null = document.querySelector(`#planbord-holder .cell[data-x="${cell.x}"].header .date-marker`);
        if (column) {
            column.classList.add('active');
        }
    }

    public static deactivateCell(): void {
        CellActivator.removeClass('active');
    }

    public static selectCell(cell: CellCoordinates): void {
        CellActivator.applyClass('selected', cell.x, cell.y);
    }

    public static deselectCell(cell: CellCoordinates): void {
        CellActivator.removeClass('selected', cell.x, cell.y);
    }

    public static deselectAllCells(): void {
        CellActivator.removeClass('selected');
    }

    private static applyClass(className: string, x: number, y: number, markerIndex: number | null = null): void {
        const el: HTMLElement | null = document.querySelector(`#planbord-holder .planbord-grid-row[data-y="${y}"] .cell[data-x="${x}"]`);
        if (!el) {
            return;
        }

        el.classList.add(className);

        if (markerIndex === null) {
            return;
        }

        const markerCell: HTMLElement | null = el.querySelector(`.deployments-holder .deploymentMarkerContainer:nth-child(${markerIndex + 1}), .stamp-holder .deploymentMarkerContainer:nth-child(${markerIndex + 1})`);
        if (!markerCell) {
            return;
        }

        markerCell.classList.add(className);
    }

    private static removeClass(className: string, x: number | null = null, y: number | null = null): void {
        let selector: string = '#planbord-holder ';
        if (y !== null) {
            selector += `.planbord-grid-row[data-y="${y}"] `;
        }
        if (x !== null) {
            selector += `.cell[data-x="${x}"]`;
        }
        selector += `.${className}`;
        document.querySelectorAll(selector).forEach((el: Element): void => {
            el.classList.remove(className);
        });
    }
}
